<template>
  <div class="liveSchedule">
    <section class="section">
      <router-link to="/live/schedule/registration">
        <b-button class="button is-primary is-large"> 配信予定登録 </b-button>
      </router-link>
    </section>
    <section class="section">
      <div class="container is-fluid">
        <div class="columns is-multiline">
          <div
            class="column is-one-quarter"
            v-for="(item, index) in lives"
            :key="index"
          >
            <router-link :to="`/live/console/${item.id}`">
              <div class="box">
                <figure class="image">
                  <img class="thumbnail" :src="item.thumbnailUrl" />
                </figure>
                <h2 class="subtitle">{{ item.title }}</h2>
                <p>{{ item.startAt }}</p>
                <p>{{ item.aboutLive }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as liveServices from '@/services/liveServices';
export default {
  name: 'LiveSchedule',
  data() {
    return {
      lives: []
    };
  },
  async created() {
    // TODO: dispatch an action
    this.lives = await liveServices.getUpcomingLivesByUserId(
      this.$store.state.auth.uid,
      10
    );
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-schedule.scss';
</style>
